import React, { Fragment, useCallback, useState, useEffect } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {
    Button,
    Col,
    Card,
    CardBody,
    Container,
    CardFooter,
    ListGroup,
    ListGroupItem,
    CardHeader,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';

import ListGroupsPageTitle from '../../../Layout/AppMain/ListGroupsPageTitle';
// import { useHistory } from 'react-router-dom';

import api from '../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../Context/Auth/AuthContext';
import ReachOutLabels from '../../../enums/ReachOutLabels';
import UserRoles from '../../../enums/UserRoles';
import GroupStatuses from '../../../enums/GroupStatuses';

export default function SearchGroup() {
    const { toggleLoading, authenticated } = useAuth();
    // const history = useHistory();

    const [groups, setGroups] = useState([]);

    const userInfo = useCallback(() => {
        if (authenticated.user) {
            return authenticated.user;
        } else {
            return authenticated;
        }
    }, [authenticated]);

    const [modal, setModal] = useState(false);
    const toggleModal = useCallback(() => {
        setModal(!modal);
    }, [setModal, modal]);

    const [modalAfter, setModalAfter] = useState(false);
    const toggleModalAfter = useCallback(() => {
        setModalAfter(!modalAfter);
    }, [setModalAfter, modalAfter]);

    const [group, setGroup] = useState();
    const joinGroup = useCallback((group) => {
        setGroup(group);
        toggleModal();        
    }, [toggleModal, setGroup]);

    // const goToGroup = useCallback(
    //     (group) => {
    //         const type = userInfo().role;

    //         setCurrentScript(null);
    //         storeCurrentGroup({
    //             role: type,
    //             ...group,
    //         });
    //         localStorage.setItem('@Reachout:groupRole', JSON.stringify(type));
    //         history.push(`/group/${group.id}`);
    //     },
    //     [history, storeCurrentGroup, setCurrentScript, userInfo]
    // );

    const submitJoinGroup = useCallback(() => {
        toggleModal();
        toggleLoading(true);
        api.patch(`ro.team.joinConfirmMember/${group.id}`, {
            role: UserRoles[(userInfo().role).toUpperCase()]
        })
            .then(() => {
                toggleModalAfter();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            }); 
    }, [toggleLoading, toggleModal, group, toggleModalAfter, userInfo]);

    useEffect(() => {
        toggleLoading(true);
        api.post('ro.team.listPublicGroups', {
            role: UserRoles[(userInfo().role).toUpperCase()]
        })
            .then((response) => {
                if (response.data.length > 0) {
                    setGroups(response.data);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, userInfo]);

    const disableJoin = useCallback((group) => {
        let disable = false;
        if (userInfo().role === 'giver') {
            if (group.isGiver && group.isGiver === true) {
                disable = true;
            }
        }else if (userInfo().role === 'receiver') {
            if (group.isReceiver && group.isReceiver === true) {
                disable = true;
            }
        }
        return disable;
    }, [userInfo]);

    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <ListGroupsPageTitle
                    heading="Search for Groups"
                    subheading="Groups accepting new participants"
                    icon="pe-7s-users icon-gradient bg-ripe-malin fontWeigth800"
                    showHomeBtn={true}
                />
                <Container fluid>
                    <Col sm={{size:10,offset:1}}>

                    <ListGroup className="todo-list-wrapper" flush>
                            
                        {groups && groups.map((group) => (
                            <ListGroupItem
                                key={group.id}
                                className="list-no-border list-no-background"
                            >
                                <Card>
                                    <CardHeader>
                                        <h5 className="m-0 p-0">
                                            {group.title}
                                            <div className="badge badge-info ml-2">{Object.keys(GroupStatuses).find(key => GroupStatuses[key] === group.status)}</div>
                                        </h5>
                                    </CardHeader>
                                    <CardBody>
                                        <p>Coordinator: {group.name}</p>
                                        {group.description}
                                    </CardBody>
                                    <CardFooter className="text-right d-block">
                                        <Button
                                            color={disableJoin(group) ? "secondary" : "primary"}
                                            size="sm"
                                            onClick={() => {
                                                joinGroup(group);
                                            }}
                                            disabled={disableJoin(group)}
                                        >
                                            {disableJoin(group) && (
                                                <Fragment>Already Joined</Fragment>
                                            )}
                                            {!disableJoin(group) && (
                                                <Fragment>Join Group</Fragment>
                                            )}
                                        </Button>
                                    </CardFooter>
                                </Card>
                            </ListGroupItem>
                        ))}

                    </ListGroup>

                    {groups && groups.length === 0 && (
                        <Card>
                            <CardBody>Sorry, there is no public groups listed!</CardBody>
                        </Card>
                    )}

                    </Col>
                </Container>

                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>
                        Join Group as {ReachOutLabels[userInfo().role]}?
                    </ModalHeader>
                    <ModalBody>
                        {group && (
                            <Fragment>
                                <p>Group: {group.title}</p>
                            <p>Coordinator: {group.name}</p>
                            <p>Description: {group.description}</p>
                            </Fragment>
                        )}                       

                        <div className="text-center">
                            <Button
                                onClick={submitJoinGroup}
                                color="info"
                            >
                                OK
                            </Button>
                            <Button
                                onClick={toggleModal}
                                color="secondary"
                                className="ml-2"
                            >
                                Cancel
                            </Button>

                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalAfter} toggle={toggleModalAfter}>
                    <ModalHeader toggle={toggleModalAfter}>
                        You requested to join the group as {ReachOutLabels[userInfo().role]}!
                    </ModalHeader>
                    <ModalBody>
                        <p>You'll be added to the group upon Coordinator's approval.</p>

                        <div className="text-center">
                            <Button
                                onClick={() => {
                                    toggleModalAfter();
                                }}
                                color="secondary"
                                className="ml-2"
                            >
                                OK
                            </Button>

                        </div>
                    </ModalBody>
                </Modal>

            </CSSTransitionGroup>
        </Fragment>
    );
}
